import { useParams } from "react-router-dom";
import { useGetMyCompanies } from "../common/useGetMyCompanies";
import { HealthcareCompanyType } from "@shared/types/commonTypes";
import { useMemo } from "react";

type UseUserPermissionsResult = {
  userPermissions: string[] | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
};

/**
 * Hook to get user permissions for the current clinic.
 * Finds the selected clinic from URL params and returns its permissions.
 */
export const useUserPermissions = (): UseUserPermissionsResult => {
  const { clinicId } = useParams();

  const { companies, isLoading, isError, error } = useGetMyCompanies({
    type: HealthcareCompanyType.DENTAL_CLINIC,
    enabled: true,
  });

  const selectedClinic = useMemo(() => {
    return companies?.find((clinic) => clinic.id === clinicId);
  }, [companies, clinicId]);

  const userPermissions: string[] | undefined =
    selectedClinic?.userPermissions?.list;

  return {
    userPermissions,
    isLoading,
    isError,
    error,
  } satisfies UseUserPermissionsResult;
};

